export function isRunningAsPwa () {
    return (
        'serviceWorker' in navigator
        && 'PushManager' in window
        && window.matchMedia('(display-mode: standalone)').matches
    );
}

export function isOnIos () {
    return (
        [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
}

interface BeforeInstallPromptEvent extends Event {
    prompt(): Promise<void>;
}

export function  promptInstall (event: BeforeInstallPromptEvent) {
    return event.prompt()
}
